import React, { FC, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { buttonsReset } from 'src/store/modules/buttons';
import { customlogReset } from 'src/store/modules/customlog';
import { editTextReset } from 'src/store/modules/editText';
import { editCurrentIndex, imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';

import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import { initTrackingValues } from '../TemplateTracking/SlideModalImageTracking';

const initViewValues = {
  currentIndex: 0,
  bgImage: {
    multi_image: [
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp'
    ]
  },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },
  radius: { multi_image: 16 },

  text: {
    multi_title: [
      'A cozy daily outerwear thats perfect for the A cozy daily outerwear thats perfect for the',
      'A template package for smart e-commerce',
      'Add an image or background image that contains text an image or background image that contains text'
    ]
  },
  fontSize: { multi_title: 1.5 },
  fontWeight: { multi_title: 700 },
  color: { multi_title: '#fff' },
  fontFamily: { multi_title: 'Montserrat' },
  textAlign: { multi_title: 'left' },

  btnText: {
    multi_right_button: ['상품더보기 1', '상품더보기 2', '상품더보기 3'],
    multi_left_button: ['닫기 1', '닫기 2', '닫기 3']
  },
  btnFontSize: { multi_right_button: 0.75, multi_left_button: 0.75 },
  btnFontWeight: { multi_right_button: 500, multi_left_button: 400 },
  btnColor: { multi_right_button: '#ffffff', multi_left_button: '#828282' },
  btnBgColorR: { multi_right_button: 0, multi_left_button: 0 },
  btnBgColorG: { multi_right_button: 0, multi_left_button: 0 },
  btnBgColorB: { multi_right_button: 0, multi_left_button: 0 },
  btnBgColorA: { multi_right_button: 0, multi_left_button: 0 },
  btnFontFamily: {
    multi_right_button: 'Montserrat',
    multi_left_button: 'Montserrat'
  }
};

const SlideModalImage: FC = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const contentsSliderRef = useRef<any>(null);

  const templateWidth = useSelector(
    (state: any) => state.template.templateWidth
  );

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );

  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiLeftButtonFontURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonFontURL = getFontURL(btnFontFamily?.multi_right_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiLeftButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_left_button}`;
  // const multiRightButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_right_button}`;
  const blackImageUrl = 'https://i.ibb.co/mSdNZgM/Frame-103.png';

  const style = `
  @Font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @Font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonFontURL});
  }
  @Font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonFontURL});
  }
  .root_view {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
  
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .center_wrapper {
      width: 100%;

      display: flex;
      flex-direction: column;
      gap: 1rem;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 16rem;
    }
    .slick-track {
      position: relative;
    }
    .slick_wrapper .slick-list {
      padding: 0 -0.5rem;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-slide {
      padding: 0 0.5rem;
    }
    .slick_image_box {
      max-width: 16rem;
      min-width: 16rem;
      max-height: 16rem;
      min-height: 16rem;
      outline: 0;
    }
    .slick_image_box img {
      max-width: 16rem;
      min-width: 16rem;
      max-height: 16rem;
      min-height: 16rem;
      object-fit: cover;
      border-radius: ${radius?.multi_image}px;
    }

    .contents_wrapper {
      margin-top: 1rem;
      width: 100%;
      padding: 0 10%;

      display: flex;
      justify-content: center;
    }
    .contents_wrapper,
    .contents_wrapper .slick-slider,
    .contents_wrapper .slick-list,
    .contents_wrapper .slick-track div,
    .contents_wrapper .slick-track img {
      height: 4.5rem;
    }
    .contents_wrapper .slick-slider {
      width: 16rem;
    }

    .contents_box {
      height: 4rem;
    }
    .contents_box .title {
      width: 100%;
      height: 4rem;
      
      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }

    .dot_wrapper {
      margin-top: 1rem;
    }
    .dot_wrapper,
    .dot_wrapper li {
      height: 0.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      list-style-type: none;
    }
    .dot_wrapper button {
      width: 0.25rem;
      height: 0.25rem;

      font-size: 0;
      border: 0;
      outline: 0;
      border-radius: 999px;
      background-color: rgba(196, 196, 196, .8);
      transition: all ease 0.3s 0s;
    }
    .dot_wrapper li.slick-active button {
      width: 1.39rem;
      background-color: rgba(230, 230, 230, 1);
    }

    .btn_wrapper {
      width: 100%;
      height: 2rem;
      padding: 0 10%;

      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
    }
    .btn_inner {
      width: 16rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.5rem;
    }
    .btn_wrapper span {
      width: 100%;
    }

    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily?.multi_left_button
          : 'multiLeftButton'
      };
      background-color:rgba(${btnBgColorR?.multi_left_button},${
    btnBgColorG?.multi_left_button
  }, ${btnBgColorB?.multi_left_button}, ${btnBgColorA?.multi_left_button});
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily?.multi_right_button
          : 'multiRightButton'
      };
      background-color:rgba(${btnBgColorR?.multi_right_button},${
    btnBgColorG?.multi_right_button
  }, ${btnBgColorB?.multi_right_button}, ${btnBgColorA?.multi_right_button});
    }

    ${
      templateWidth < 321.25
        ? `
        .slick_wrapper,
        .slick_wrapper .slick-slider,
        .slick_wrapper .slick-list {
          height: 14rem;
        }
        .slick_image_box,
        .slick_image_box img {
          max-width: 14rem;
          min-width: 14rem;
          max-height: 14rem;
          min-height: 14rem;
        }

        .contents_wrapper,
        .contents_wrapper .slick-slider,
        .contents_wrapper .slick-list,
        .contents_wrapper .slick-track div,
        .contents_wrapper .slick-track img {
          height: 4rem;
        }
        .slick-slider {
          width: 14rem;
        }
        .contents_box .title {
          height: 4rem;
          font-size: ${fontSize?.multi_title - 0.25}rem;
        }
        .title .title_inner {
          max-height: 3.4rem;
        }
        .contents_wrapper .slick-slider {
          width: 14rem;
        }

        .btn_inner {
          width: 14rem;
        }
        `
        : ''
    }

    ${
      templateWidth > 767
        ? `
        .slick_wrapper,
        .slick_wrapper .slick-slider,
        .slick_wrapper .slick-list {
          height: 24rem;
        }
        .slick_image_box,
        .slick_image_box img {
          max-width: 24rem;
          min-width: 24rem;
          max-height: 24rem;
          min-height: 24rem;
        }

        .contents_wrapper,
        .contents_wrapper .slick-slider,
        .contents_wrapper .slick-list,
        .contents_wrapper .slick-track div,
        .contents_wrapper .slick-track img {
          height: 6rem;
        }
        .contents_wrapper .slick-slider {
          width: 24rem;
        }

        .contents_box .title {
          height: 6rem;
          font-size: ${fontSize?.multi_title + 0.25}rem;
        }
        .title .title_inner {
          max-height: 4.2rem;
        }

        .btn_inner {
          width: 24rem;
        }
        .btn_wrapper .style01 {
          font-size: ${btnFontSize?.multi_right_button + 0.125}rem;
        }
        .btn_wrapper .style02 {
          font-size: ${btnFontSize?.multi_left_button + 0.125}rem;
        }
      `
        : ''
    }
  }
  `;

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    contentsSliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex]);

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());

      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);

  const settings = {
    arrows: false,
    dots: true,

    dotsClass: 'dot_wrapper',
    appendDots: dots => <div id="id_dot_wrapper">{dots}</div>,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 300,
    touchThreshold: 300
  };

  const contentsSettings = {
    arrows: false,
    dots: false,
    fade: true,

    speed: 300,
    swipe: false
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div className="center_wrapper">
          <div className="slick_wrapper">
            <Slider
              {...settings}
              ref={sliderRef}
              afterChange={index => {
                dispatch(editCurrentIndex(index));
                contentsSliderRef.current.slickGoTo(index);
              }}
            >
              {bgImage?.multi_image?.map((data: any, idx: number) => (
                <div key={idx} className="slick_image_box">
                  <img
                    src={!data || data === '' ? blackImageUrl : data}
                    alt=""
                  />
                </div>
              ))}
            </Slider>
          </div>
          <div className="contents_wrapper">
            <Slider {...contentsSettings} ref={contentsSliderRef}>
              {text?.multi_title?.map((data: any, idx: number) => (
                <div key={idx} className="contents_box">
                  <div className="title">
                    <span className="title_inner">
                      {changeEnter(text?.multi_title?.[idx])}
                    </span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className="btn_wrapper">
            <div className="btn_inner">
              <span className="style01">
                {btnText?.multi_left_button?.[currentIndex]}
              </span>
              <span className="style02">
                {btnText?.multi_right_button?.[currentIndex]}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SlideModalImage;
